import { render, staticRenderFns } from "./LeaveStatusChip.vue?vue&type=template&id=7318bbea"
import script from "./LeaveStatusChip.vue?vue&type=script&lang=js"
export * from "./LeaveStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports